import { Component, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../kiene-core.config';
import { KieneBackendApiService } from '../../../services/backend-api/kiene-backend-api.service';
import { MessageService } from '../../../services/message-service/message.service';
import { GruppeTier } from '../classes/gruppe-tier';

export interface GruppeTierPreiseFestlegenDialogInput {
    gruppeTiere: GruppeTier[];
}

@Component({
    selector: 'kiene-gruppe-tier-preise-festlegen-dialog',
    templateUrl: './gruppe-tier-preise-festlegen-dialog.component.html',
    styleUrls: ['./gruppe-tier-preise-festlegen-dialog.component.scss'],
})
export class GruppeTierPreiseFestlegenDialogComponent {
    preisCtrl = new FormControl<number | null>(null, [Validators.required, Validators.min(0)]);
    isLoading = false;

    constructor(
        public dialogRef: MatDialogRef<GruppeTierPreiseFestlegenDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: GruppeTierPreiseFestlegenDialogInput,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private api: KieneBackendApiService,
        private messageService: MessageService,
    ) {}

    get anzahlTiere(): number {
        return this.data?.gruppeTiere?.length || 0;
    }

    close(): void {
        this.dialogRef.close();
    }

    save(): void {
        if (this.preisCtrl.invalid) {
            this.messageService.errorMessage('Bitte geben Sie einen gueltigen Preis ein.', null);
            return;
        }

        const preis = this.preisCtrl.value;
        if (preis === null) {
            this.messageService.errorMessage('Bitte geben Sie einen Preis ein.', null);
            return;
        }

        this.isLoading = true;
        const updateData = {
            gruppe_tiere: this.data.gruppeTiere.map(gt => ({ gt_id: gt.gt_id })),
            ek_brutto: preis,
        };

        this.api.post(this.apiBaseUrl + 'gruppe_tier/update_preise_selektierte_tiere.php', updateData).subscribe({
            next: () => {
                this.messageService.infoMessage('Die Preise wurden erfolgreich gespeichert');
                this.dialogRef.close(true);
            },
            error: err => {
                this.messageService.errorMessage('Fehler beim Speichern der Preise', err);
                this.isLoading = false;
            },
        });
    }

    deletePrices(): void {
        this.isLoading = true;
        const deleteData = {
            gruppe_tiere: this.data.gruppeTiere.map(gt => ({ gt_id: gt.gt_id })),
            ek_brutto: null,
        };

        this.api.post(this.apiBaseUrl + 'gruppe_tier/update_preise_selektierte_tiere.php', deleteData).subscribe({
            next: () => {
                this.messageService.infoMessage('Die Preise wurden erfolgreich geloescht');
                this.dialogRef.close(true);
            },
            error: err => {
                this.messageService.errorMessage('Fehler beim Loeschen der Preise', err);
                this.isLoading = false;
            },
        });
    }
}
